import * as React from "react";
import { Button, Row, Col } from "reactstrap";

import { connect } from "react-redux";
import Slider, { createSliderWithTooltip } from "rc-slider";
import "../../style/slider.scss";
import {
  ApplicationAction,
    setAmountOther,
  setRepaymentPeriod,
  gotoStep
} from "../../store/application/applicationActions";
import { RootState } from "../../store";
import ApplicationContent from "../applicationContent";
import ApplicationFooter from "../applicationFooter";
import LoanDetails from "./LoanDetails";
import { Step } from "../../store/application/applicationState";
import { StringUtil } from "../../util/stringUtil";
import ApplicationHeader from "../applicationHeader";
import { trackEvent } from "../../util/gtm";




const SliderWithTooltip = createSliderWithTooltip(Slider);

type Props = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

class StepTwo extends React.Component<Props, {}> {
  constructor(props: any) {
    super(props);
  }

  amountFormatter(value: number): string {
    return StringUtil.numberWithCommas(value) + " kr.";
  }

  monthFormatter(value: number): string {
    return value + " mdr.";
  }
    uuidEmit = () => {
        // Get now time
        const n = Date.now();
        // Generate random
        const r = Math.random();
        // Stringify now time and generate additional random number
        const s = String(n) + String(~~(r * 9e4) + 1e4);
        // Form UUID and return it
        return `${s.slice(0, 8)}-${s.slice(8, 12)}-4${s.slice(12, 15)}-${[8, 9, 'a', 'b'][~~(r * 3)]}${s.slice(15, 18)}-${s.slice(s.length - 12)}`;
    };
  render() {
    var btnSize = {
      width: "115px",
      height: "50px"
    };

    return (
      <div>
        <ApplicationHeader>
          <Row>
            <Col className="mb-3">
              <LoanDetails />
            </Col>
          </Row>
        </ApplicationHeader>
        <ApplicationContent>
          <h2 className="mb-5">Justér beløb og vælg løbetid</h2>

          <SliderWithTooltip
            tipFormatter={this.amountFormatter}
            tipProps={{ defaultVisible: true, visible: true }}
            onChange={this.props.setAmount}
            step={5000}
            min={10000}
            max={150000}
            defaultValue={this.props.application.data.loanAmount}
          />
          <div className="d-flex justify-content-between slider mb-5">
            <div className="label">10.000 kr.</div>
            <div className="label">150.000 kr.</div>
          </div>

          <SliderWithTooltip
            tipFormatter={this.monthFormatter}
            tipProps={{ defaultVisible: true, visible: true }}
            onChange={this.props.setRepaymentPeriod}
            step={12}
            min={24}
            max={120}
            defaultValue={72}
          />

          {/* > 768px */}
                <div className="justify-content-between slider d-md-flex d-none" style={{ width: "108%", marginLeft: "-4%" }}>
            <Row style={{width: "100%", margin: 0}}>
            <Col style={{ width: "10%", textAlign: "left", padding: 0}}>
                <div className="label">24 måneder</div>
              </Col>
            <Col style={{ width: "10%", textAlign: "left", padding: 0 }}>
                <div className="label">36 måneder</div>
              </Col>
            <Col style={{ width: "10%", textAlign: "center", padding: 0 }}>
                <div className="label">48 måneder</div>
              </Col>
            <Col style={{ width: "10%", textAlign: "center", padding: 0 }}>
                <div className="label">60 måneder</div>
              </Col>
              <Col style={{ width: "10%", textAlign: "center", padding: 0 }}>
                <div className="label">72 måneder</div>
                </Col>
                <Col style={{ width: "10%", textAlign: "center", padding: 0 }}>
                <div className="label">84 måneder</div>
                </Col>
                <Col style={{ width: "10%", textAlign: "center", padding: 0 }}>
                <div className="label">96 måneder</div>
                </Col>
                <Col style={{ width: "10%", textAlign: "right", padding: 0 }}>
                <div className="label">108 måneder</div>
                </Col>
                <Col style={{ width: "10%", textAlign: "right", padding: 0 }}>
                <div className="label">120 måneder</div>
              </Col>
            </Row>
          </div>

          {/* <= 768px */}
          <div className="justify-content-between slider d-md-none d-flex">
            <div className="label">24 mdr</div>
            <div className="label">120 mdr</div>
          </div>
        </ApplicationContent>
        <ApplicationFooter>
                <Row className="mt-2">
                    <Col className="col-12 col-lg-8 text-center  d-sm-none">

                    </Col>
                    <Col className="col-6 col-lg-8 d-none d-md-block">
                    </Col>
                    <Col className="col-4 d-md-none"></Col>
                    <Col className="col-12 col-md-6 col-lg-4 text-right">
                        <Button className="back" onClick={() => this.props.previous()}>
                            Tilbage
              </Button>
              <Button
                            className="next AmountRuntimeButton"
                            style={btnSize}
                            onClick={() => {
                                this.props.amountChosen();

                                trackEvent(
                                    "Justér beløb og vælg løbetid",
                                    "Beløb: " + this.props.application.data.loanAmount.valueOf() + "| Mdr.: " + this.props.application.data.repaymentPeriod,
                                    "Valgt beløb og løbetid",
                                    this.props.amountChosen()
                                )
                            }}
              >
                Næste
              </Button>
            </Col>
          </Row>
        </ApplicationFooter>
      </div>
    );
    }

}

const SliderHandle: React.FunctionComponent = () => {
  return <img src="/images/slider-dot.svg" />;
};

const mapStateToProps = (state: RootState) => ({
  application: state.applicationState
});

const mapDispatchToProps = (dispatch: (action: ApplicationAction) => void) => ({
    setAmount: (amount: number) => dispatch(setAmountOther(amount)),
  setRepaymentPeriod: (months: number) => dispatch(setRepaymentPeriod(months)),
    amountChosen: () => dispatch(gotoStep(Step.Contact)),
    previous: () => dispatch(gotoStep(Step.Main))
});



export default connect(mapStateToProps, mapDispatchToProps)(StepTwo);
